export const Endpoints = {
    baseUrl: 'https://api.plaiuri.ro/api'
    // baseUrl: 'http://localhost:8081/api'
}